import { useLocation } from 'react-router-dom';
import NavigationPrompt from 'react-router-navigation-prompt';
import { useTranslation } from 'react-i18next';

// Import helpers
import { CONFIGURATOR_STEPS, ALLOWED_PATHS } from 'components/views/offer_configurator/helpers/steps';
import { sendPacketsLeaveCheckoutEvent } from 'helpers/tracking';

// Import routes
import { MAIN_PATHS } from 'components/routes/app_routes/paths';

// Import styles
import { Wrapper, Container, StepTitle, CloseButton, StyledCloseIcon } from './styles';

// Import components
import { Steps } from './components';
import { AntModal } from 'components/views/offer_configurator/components/common';

// Import hooks
import { useSummaryStore } from 'components/views/offer_configurator/hooks/useSummaryStore';

type Props = {
	isSubscription: boolean;
};

const NavigationBar = ({ isSubscription }: Props) => {
	const { t } = useTranslation('configurator');
	const { pathname } = useLocation();
	const [summary, clearSummaryStore] = useSummaryStore(({ summary, clearSummaryStore }) => [summary, clearSummaryStore]);

	const activeStep = CONFIGURATOR_STEPS.findIndex(({ path }) => path === pathname);

	if (activeStep === -1) return null;

	const activeStepTitle = CONFIGURATOR_STEPS[activeStep].title;

	const title = activeStepTitle === 'summary' && isSubscription ? 'summary_of_changes' : activeStepTitle;

	const handleConfirm = () => {
		sendPacketsLeaveCheckoutEvent(summary?.products, summary?.current_price);
		clearSummaryStore();
	};

	return (
		<Wrapper>
			<Container>
				<Steps activeStep={activeStep} />

				<StepTitle>{t(title)}</StepTitle>

				<CloseButton to={MAIN_PATHS.OFFER_CONFIGURATOR}>
					<StyledCloseIcon />
				</CloseButton>
			</Container>

			<NavigationPrompt
				disableNative
				afterConfirm={handleConfirm}
				when={(_current, next, type) => {
					if (type === 'REPLACE') return false;
					return !ALLOWED_PATHS.includes(`${next?.pathname}`);
				}}
			>
				{({ onCancel, onConfirm }) => (
					<AntModal
						namespace="configurator"
						title="modal_abandonment_title"
						description={{ key: 'modal_abandonment_description' }}
						confirmText="button_leave"
						cancelText="button_cancel"
						onConfirm={onConfirm}
						onCancel={onCancel}
						visible
					/>
				)}
			</NavigationPrompt>
		</Wrapper>
	);
};

export default NavigationBar;
